export default function () {
    return {
        empty: 'Обязательно для заполнения.',
        incorrectEmail: 'Неправильный E-mail.',
        textSuccess: 'Успешно!',
        textSuccessSubscribe: 'Спасибо за подписку!',
        textSubscribed: 'Ваша подписка была подтверждена.',
        textError: 'Извините, произошла ошибка :(',
        textRequestError: 'Ошибка при отправке формы, попробуйте еще раз, но позже ...',
    };
}
